export default __webpack_public_path__ + "static/media/deludovico.e33fa77f.jpg";